module.exports = __webpack_public_path__ + "static/media/Thumbnail2.666db3da.png";